<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Mantenimiento de pagos del repartidor
      </h2>
      <ListDeliveryMan />
    </div>
  </template>
  
  <script>
  import ListDeliveryMan from "@/components/DeliveryMan/ListDeliveryMan.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "MainDeliveryMan",
    components: {
        ListDeliveryMan,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  